import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
      {categories.map((c, i) => (
        <Link
          key={c.id}
          to={`/category/${c.id}`}
          className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 animate-fade-up md:p-5"
          style={{ animationDelay: `${i * 80}ms` }}
        >
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50 transition-colors group-hover:bg-accent-500">
            <i className={`${c.icon} text-2xl`}></i>
          </span>
          <span className="min-w-0">
            <span className="block font-heading text-lg font-bold text-foreground-950">
              {c.name}
            </span>
            <span className="mt-1 block text-xs leading-relaxed text-foreground-600 line-clamp-2">
              {c.description}
            </span>
          </span>
          <span className="ml-auto mt-1 flex h-6 w-6 shrink-0 items-center justify-center text-foreground-400 transition-all group-hover:translate-x-1 group-hover:text-primary-600">
            <i className="ri-arrow-right-line"></i>
          </span>
        </Link>
      ))}
    </div>
  );
}